import {
  MODAL_EXPORT_FIGMA,
  MODAL_SHARE,
} from '@components/App/Modal/constants'
import { Tab } from '@components/App/Modal/Share/Share'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

export const useExportAsFigma = (withBack?: boolean) => {
  const dispatch = useDispatch()

  return () => {
    dispatch(
      openModal({
        modalType: MODAL_EXPORT_FIGMA,
        modalProps: {
          ...(withBack && {
            onBack: {
              to: MODAL_SHARE,
              params: {
                activeTab: Tab.Export,
              },
            },
          }),
        },
      })
    )
  }
}
